export default "__VITE_ASSET__CZCZ8gZe__"